<div class="page-header">
  <app-prev-next-button direction="left" label="estoque" (click)="navigateToStock()"></app-prev-next-button>
  <h1>Saída</h1>
</div>
<div class="ctrl-bar">
  <div class="buttons">
    <div class="inventory-btn">
      <button mat-raised-button (click)="openSidenav('STOCK_INVENTORY')">
        Inventariar
      </button>
    </div>
    <div class="remove-btn-wrapper">
      <button mat-raised-button class="secondary-2"
        (click)="openSidenav('REMOVE_PALLETS')">
        Limpar Posição
      </button>
    </div>

    <div class="update-button">
      <p>Atualizado às {{ actualHour }}</p>
      <button mat-raised-button (click)="update()">
        <i class="uil uil-sync"></i>
        <span>Atualizar</span>
      </button>
    </div>
  </div>
</div>
<app-side-color-card color="primary-1">
  <div content class="card-content">
    <div class="card-header">
      <h2>Pallets ({{ exitService.totalItems$ | async | number:'1.0-0':'pt-BR' }}) - Produtos ({{totalProductsCount | number:'1.0-0':'pt-BR'}})</h2>
      <div class="paginator-container">
        <app-paginator
          [currentPage]="exitService.currentPage$ | async"
          [pageCount]="exitService.pageCount$ | async"
          [atFirstPage]="exitService.atFirstPage$ | async"
          [atLastPage]="exitService.atLastPage$ | async"
          [pageSize]="exitService.pageSize$ | async"
          [pageSizeOptions]="exitService.pageSizeOptions$ | async"
          (nextPage)="getNextPage()"
          (previousPage)="getPreviousPage()"
          (pageSizeChange)="onPageSizeChange($event)"
          (pageChange)="onPageChange($event)"
        ></app-paginator>
      </div>
    </div>
    <div class="table">
      <app-exit-table
        [crates]="cratesArray"
        (clicked)="onRowClick($event)"
        (onFilterValuesChange)="onFiltersApply($event)">
      </app-exit-table>
      <div *ngIf="isLoading" class="loader">
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>
      <div class="empty" *ngIf="cratesArray?.length === 0 && !isLoading">
        NÃO EXISTEM PALLETS NA POSIÇÃO DE SAÍDA.
      </div>
    </div>
  </div>
</app-side-color-card>

<app-full-page-loader *ngIf="isModalLoading"></app-full-page-loader>